/** Embedded AI disclaimer “Learn more” — swap for the final Help Center article when ready. */
export const AI_EMBEDDED_DISCLAIMER_LEARN_MORE_URL = 'https://help.calendly.com/hc/en-us/articles/36763109075735-AI-at-Calendly'

export const AI_CHAT_DISCOVERY_NAVIGATION_LOCATION_TOP_RIGHT = 'ask_ai_top_right'

/** Scheduling-assistant BOOLEAN — set when user engages intro modal (close, Not now, or Try Callie). */
export const AI_CHAT_DISCOVERY_INTRO_MODAL_DISMISSED_SETTING_NAME = 'ai_exec_assistant_discovery_intro_modal_dismissed'

/** Callie scheduling assistant email address shown in discovery intro modal. */
export const CALLIE_SCHEDULING_EMAIL = 'callie@calendly.com'

/** Intro modal email-card hero panel dimensions (Figma node 1891:171966). */
export const AI_CHAT_DISCOVERY_INTRO_HERO_WIDTH_PX = 270
export const AI_CHAT_DISCOVERY_INTRO_HERO_HEIGHT_PX = 260

/** Discovery video modal shell + poster (Figma node 2454:249734). */
export const AI_CHAT_DISCOVERY_VIDEO_POSTER_HEIGHT_PX = 394

/** Same Wistia media as home `WatchHowItWorksOverlay` Callie intro video. */
export const AI_CHAT_DISCOVERY_VIDEO_WISTIA_ID = 'y16pflxpaq'
